export default function TermsConditions() {
    return (
        <div className="w-full bg-white">
            <div className="max-w-5xl mx-auto px-6 py-14">

                {/* PAGE TITLE */}
                <h1 className="text-3xl font-semibold text-gray-900 mb-6">
                    Terms & Conditions
                </h1>

                <p className="text-gray-700 leading-relaxed mb-6">
                    Welcome to <strong>Tech Article Hub</strong>. By accessing and using this
                    website, you agree to comply with and be bound by the following Terms and
                    Conditions. Please read them carefully before using our website.
                </p>

                {/* USE OF WEBSITE */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Use of the Website
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    The content published on Tech Article Hub is provided for general
                    information and educational purposes only. You agree to use this website
                    in a lawful manner and not engage in any activity that may harm, disrupt,
                    or misuse the website or its content.
                </p>

                {/* CONTENT ACCURACY */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Content Accuracy
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    We make every effort to ensure that the information on this website is
                    accurate and up to date. However, we do not guarantee the completeness,
                    reliability, or accuracy of any content. Any reliance you place on the
                    information found on this website is strictly at your own risk.
                </p>

                {/* INTELLECTUAL PROPERTY */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Intellectual Property
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    All content on Tech Article Hub, including text, images, logos, and design
                    elements, is the intellectual property of Tech Article Hub unless otherwise
                    stated. You may not copy, reproduce, republish, or distribute any content
                    without prior written permission.
                </p>

                {/* THIRD-PARTY LINKS */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Third-Party Links
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    Our website may contain links to third-party websites for reference or
                    convenience. Tech Article Hub has no control over the content or policies
                    of these external sites and is not responsible for any loss or damage
                    arising from your use of third-party websites.
                </p>

                {/* ADVERTISING */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Advertising and Affiliate Disclosure
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    Tech Article Hub may display advertisements provided by third-party
                    advertising networks such as Google AdSense. These ads help support the
                    operation of the website. We do not endorse or guarantee the products or
                    services advertised unless explicitly stated.
                </p>

                {/* LIMITATION OF LIABILITY */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Limitation of Liability
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    Tech Article Hub shall not be held liable for any direct, indirect,
                    incidental, or consequential damages arising from the use of this website
                    or reliance on its content. This includes, but is not limited to, loss of
                    data, profits, or business opportunities.
                </p>

                {/* USER RESPONSIBILITY */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    User Responsibilities
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    Users are responsible for ensuring that any information or actions taken
                    based on content from this website comply with applicable laws and
                    regulations. You agree not to misuse this website for unlawful or harmful
                    purposes.
                </p>

                {/* TERMINATION */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Termination of Access
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    We reserve the right to restrict or terminate access to the website, without
                    notice, if we believe a user has violated these Terms & Conditions or engaged
                    in inappropriate behavior.
                </p>

                {/* CHANGES */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Changes to These Terms
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    Tech Article Hub may update these Terms & Conditions from time to time.
                    Any changes will be posted on this page and will take effect immediately
                    upon publication.
                </p>

                {/* GOVERNING LAW */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Governing Law
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    These Terms & Conditions shall be governed by and interpreted in accordance
                    with applicable laws. Any disputes arising from the use of this website
                    shall be subject to the appropriate legal jurisdiction.
                </p>

                {/* CONTACT */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Contact Information
                </h2>

                <p className="text-gray-700 leading-relaxed mb-10">
                    If you have any questions about these Terms & Conditions, please contact
                    us at <strong>contact@techarticlehub.com</strong>.
                </p>

                <p className="text-sm text-gray-500">
                    Last updated: {new Date().toLocaleDateString("en-US")}
                </p>

            </div>
        </div>
    );
}
